@if (active()) {
  <div [class]="classes().frame" aria-hidden="true"></div>
  <div role="status" [class]="classes().tab">
    <span class="flex min-w-0 items-center gap-1">
      <span [class]="classes().muted" class="sr-only sm:not-sr-only">
        {{ 'components.impersonation.signedInAs' | transloco }}
      </span>
      <span
        class="max-w-[45vw] truncate font-semibold sm:max-w-none"
        [vTooltip]="user()?.email"
        vTooltipPosition="bottom">
        {{ userName() }}
      </span>
    </span>

    <span [class]="classes().muted" class="hidden sm:inline">·</span>
    @if (impersonation(); as impersonation) {
      <span class="sr-only sm:not-sr-only">
        @if (impersonation.readOnly) {
          {{ 'components.impersonation.readOnly' | transloco }}
        } @else {
          {{ 'components.impersonation.changesAllowed' | transloco }}
        }
      </span>

      <span [class]="classes().muted" class="hidden sm:inline">·</span>
      <span
        class="hidden items-center gap-1 tabular-nums sm:inline-flex"
        [vTooltip]="
          'components.impersonation.endsAt'
            | transloco
              : {
                  time:
                    impersonation.expiresAt
                    | localeDate
                      : 'time'
                      : { hour: '2-digit', minute: '2-digit' },
                }
        "
        vTooltipPosition="bottom">
        <vx-icon name="timer" size="xs" />
        {{ remainingSeconds() | duration: 'single-unit' }}
      </span>
    } @else {
      <span class="sr-only sm:not-sr-only">
        {{ 'components.impersonation.unknown' | transloco }}
      </span>
    }

    <button
      type="button"
      [class]="classes().end"
      [disabled]="ending()"
      (click)="end()">
      <vx-icon name="sign-out" size="xs" />
      <span class="sr-only sm:not-sr-only">
        {{ 'components.impersonation.end' | transloco }}
      </span>
    </button>
  </div>
}
